const makePieceSet = (themeName) => {
  const pieces = ['wR', 'wN', 'wB', 'wQ', 'wK', 'wP', 'bR', 'bN', 'bB', 'bQ', 'bK', 'bP'];
  const set = {};
  pieces.forEach(p => {
    set[p] = `https://cdn.jsdelivr.net/gh/lichess-org/lila@master/public/piece/${themeName}/${p}.svg`;
  });
  return set;
};

const makePieceSet3D = (themeName, baseUrl) => {
  const mapping = {
    wP: 'White-Pawn.png',
    wR: 'White-Rook.png',
    wN: 'White-Knight.png',
    wB: 'White-Bishop.png',
    wQ: 'White-Queen.png',
    wK: 'White-King.png',
    bP: 'Black-Pawn.png',
    bR: 'Black-Rook.png',
    bN: 'Black-Knight.png',
    bB: 'Black-Bishop.png',
    bQ: 'Black-Queen.png',
    bK: 'Black-King.png'
  };
  const set = {};
  for (let key in mapping) {
    set[key] = `${baseUrl}/${mapping[key]}`;
  }
  return set;
};

const THEME_NAMES = [
  'cburnett', 'merida', 'alpha', 'maestro', 'staunty', 'caliente', 'california',
  'cardinal', 'dubrovny', 'fantasy', 'fresca', 'governor', 'horsey', 'kiwen-suwi',
  'kosal', 'leipzig', 'letter', 'pixel', 'riohacha', 'shapes',
  'spatial', 'tatiana', 'pirouetti', 'chess7', 'companion',
  'celtic'
];

const THEMES_3D = {
  staunton3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/Basic/Scaled/180',
  experimental3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/Experimental/Scaled/180',
  glass3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/Glass/Scaled/180',
  metal3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/Metal/Scaled/180',
  jade3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/ModernJade/Scaled/180',
  modernwood3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/ModernWood/Scaled/180',
  redvblue3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/RedVBlue/Scaled/180',
  tournament3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/Tournament/Scaled',
  wax3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/Wax/Scaled/180',
  classicwood3d: 'https://cdn.jsdelivr.net/gh/clarkerubber/Staunton-Pieces@master/Renders/Wood/Scaled/180'
};

export const PIECE_SETS = {};
THEME_NAMES.forEach(theme => {
  PIECE_SETS[theme] = makePieceSet(theme);
});
for (let key in THEMES_3D) {
  PIECE_SETS[key] = makePieceSet3D(key, THEMES_3D[key]);
}


export const BOARD_THEMES = {
  green:  { light: '#eeeed2', dark: '#769656' },
  wood:   { light: '#f0d9b5', dark: '#b58863' },
  blue:   { light: '#dee3e6', dark: '#8ca2ad' },
  sand:   { light: '#e3c598', dark: '#b88b4a' },
  canvas: { light: '#e2d5c5', dark: '#988775' },
  maple:  { light: '#e5c29a', dark: '#b57a53' },
  ic:     { light: '#c2d2e1', dark: '#7596b6' },
  grey:   { light: '#cfd8dc', dark: '#90a4ae' },
  metal:  { light: '#b0bec5', dark: '#78909c' },
  olive:  { light: '#e5e5b3', dark: '#8c9966' },
  purple: { light: '#d2c3d9', dark: '#8a6d96' },
  pink:   { light: '#f3d6db', dark: '#c27a85' },
  horn:   { light: '#edd4ba', dark: '#b6805c' },
  newspaper: { light: '#d6d6d6', dark: '#9e9e9e' }
};

export const STAR_ICON = 'https://upload.wikimedia.org/wikipedia/commons/2/29/Gold_Star.svg';
export const CUTE_ITEMS = ['⭐', '🍎', '🍌', '🍉', '🍩', '🍦', '🎈', '🎁', '🧸', '💎', '🦄'];

// 🔥 THE FIX: Use jsDelivr CDN and .mp3 format for 100% Browser Compatibility
const SOUND_URLS = {
    move: 'https://cdn.jsdelivr.net/gh/lichess-org/lila@master/public/sound/standard/Move.mp3',
    capture: 'https://cdn.jsdelivr.net/gh/lichess-org/lila@master/public/sound/standard/Capture.mp3',
    notify: 'https://cdn.jsdelivr.net/gh/lichess-org/lila@master/public/sound/standard/GenericNotify.mp3',
    collect: 'https://cdn.jsdelivr.net/gh/lichess-org/lila@master/public/sound/standard/Victory.mp3',
    error: 'https://cdn.jsdelivr.net/gh/lichess-org/lila@master/public/sound/standard/Error.mp3'
};

// 🔥 PRE-LOADER: Loads audio in background so browser doesn't block it later
export const AUDIO_OBJECTS = {};
if (typeof window !== 'undefined') {
    for (let key in SOUND_URLS) {
        AUDIO_OBJECTS[key] = new Audio(SOUND_URLS[key]);
        AUDIO_OBJECTS[key].preload = 'auto';
    }
}

export const playSound = (type) => {
    try { 
        if (AUDIO_OBJECTS[type]) {
            AUDIO_OBJECTS[type].currentTime = 0; // Rewind to start
            // Play instantly from memory
            AUDIO_OBJECTS[type].play().catch(e => console.warn('Audio blocked by browser:', e));
        }
    } catch(e){}
};

export const getSquareCoords = (sq, isFlipped) => { 
    const f = sq.charCodeAt(0) - 97; 
    const r = parseInt(sq[1]) - 1; 
    const cx = isFlipped ? (7 - f) * 12.5 + 6.25 : f * 12.5 + 6.25; 
    const cy = isFlipped ? r * 12.5 + 6.25 : (7 - r) * 12.5 + 6.25; 
    return { cx, cy }; 
};

export const getPseudoLegalMoves = (tempGame, sq, validTargets = []) => {
    let moves = tempGame.moves({ square: sq, verbose: true }).map(m => m.to);
    const piece = tempGame.get(sq); if (!piece) return moves;
    const cols = ['a','b','c','d','e','f','g','h']; const f = cols.indexOf(sq[0]); const r = parseInt(sq[1]);
    if (piece.type === 'p') { const dir = piece.color === 'w' ? 1 : -1; [-1, 1].forEach(df => { const targetSq = `${cols[f+df]}${r+dir}`; if (validTargets.includes(targetSq) && !moves.includes(targetSq)) moves.push(targetSq); }); }
    if (moves.length > 0) return moves;
    moves = []; 
    const checkDir = (df, dr, max) => { for (let i=1; i<=max; i++) { const nf = f + df*i; const nr = r + dr*i; if (nf<0 || nf>7 || nr<1 || nr>8) break; const tSq = `${cols[nf]}${nr}`; const tPiece = tempGame.get(tSq); if (!tPiece || validTargets.includes(tSq)) { moves.push(tSq); if(validTargets.includes(tSq)) break; } else { if (tPiece.color !== piece.color) moves.push(tSq); break; } } };
    if (piece.type === 'n') { [[1,2],[2,1],[-1,2],[-2,1],[1,-2],[2,-1],[-1,-2],[-2,-1]].forEach(d => { const nf = f+d[0]; const nr = r+d[1]; if(nf>=0 && nf<=7 && nr>=1 && nr<=8) { const targetSq = `${cols[nf]}${nr}`; const tp = tempGame.get(targetSq); if(!tp || tp.color !== piece.color || validTargets.includes(targetSq)) moves.push(targetSq); } }); }
    else if (piece.type === 'r') { [[0,1],[1,0],[0,-1],[-1,0]].forEach(d => checkDir(d[0], d[1], 7)); } 
    else if (piece.type === 'b') { [[1,1],[1,-1],[-1,1],[-1,-1]].forEach(d => checkDir(d[0], d[1], 7)); } 
    else if (piece.type === 'q') { [[0,1],[1,0],[0,-1],[-1,0],[1,1],[1,-1],[-1,1],[-1,-1]].forEach(d => checkDir(d[0], d[1], 7)); } 
    else if (piece.type === 'k') { [[0,1],[1,0],[0,-1],[-1,0],[1,1],[1,-1],[-1,1],[-1,-1]].forEach(d => checkDir(d[0], d[1], 1)); } 
    else if (piece.type === 'p') { const dir = piece.color === 'w' ? 1 : -1; const startR = piece.color === 'w' ? 2 : 7; if (r+dir>=1 && r+dir<=8 && !tempGame.get(`${cols[f]}${r+dir}`)) { moves.push(`${cols[f]}${r+dir}`); if (r === startR && !tempGame.get(`${cols[f]}${r+dir*2}`)) moves.push(`${cols[f]}${r+dir*2}`); } [-1, 1].forEach(df => { if (f+df>=0 && f+df<=7 && r+dir>=1 && r+dir<=8) { const targetSq = `${cols[f+df]}${r+dir}`; const tp = tempGame.get(targetSq); if ((tp && tp.color !== piece.color) || validTargets.includes(targetSq)) moves.push(targetSq); } }); }
    return moves;
};
